module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "middle-box text-center loginscreen animated fadeInDown"
  }, [_c('div', [_c('br'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.failText),
      expression: "failText"
    }],
    staticClass: "bg-danger p-xs b-r-sm"
  }, [_vm._v(_vm._s(_vm.failText))]), _c('form', {
    staticClass: "m-t",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "placeholder": "Username",
      "required": "required"
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": "required"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary block full-width m-b",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogingIn),
      expression: "!isLogingIn"
    }]
  }, [_vm._v("Login")]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogingIn),
      expression: "isLogingIn"
    }],
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo text-center"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f92f0ee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login.vue
// module id = 404
// module chunks = 3